import {ExamModule, mapExamModuleDbToType} from '@cp/model';
import {getDoc} from 'firebase/firestore';
import getExamModuleDocRef from './getExamModuleDocRef';

export default async function getExamModuleDoc(id: string): Promise<ExamModule | undefined> {
  const ref = getExamModuleDocRef(id);
  const snapshot = await getDoc(ref);
  return mapExamModuleDbToType(snapshot);
}
